import type { ChangeEvent } from 'react';
import { handleKeyPress, handlePaste } from './utils';

interface GradeInputColumnProps {
  testId?: string;
  value?: string; // A string of dd
  disabled?: boolean;
  label?: string;
  anchorId?: string;
  allowFloat?: boolean;
  decimalPlaces?: number;
  onChange?(value: string): void;
}

export default function GradeInputColumn({
  testId,
  value = '',
  disabled = false,
  label,
  anchorId,
  allowFloat = false,
  decimalPlaces,
  onChange,
}: GradeInputColumnProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let nextValue = `${event.target.value}`;
    if (allowFloat && typeof decimalPlaces === 'number' && decimalPlaces >= 0) {
      const floatWithPrecisionRegExp = new RegExp(`^-?\\d*(?:\\.\\d{0,${decimalPlaces}})?$`);
      if (!floatWithPrecisionRegExp.test(nextValue) && nextValue.includes('.')) {
        const [whole, fraction = ''] = nextValue.split('.', 2);
        nextValue = `${whole}.${fraction.slice(0, decimalPlaces)}`;
      }
      if (!floatWithPrecisionRegExp.test(nextValue)) {
        return;
      }
    }
    onChange?.(nextValue);
  };

  return (
    <div className="govuk-date-input__item">
      <div className="govuk-form-group">
        <label className="govuk-label govuk-date-input__label" htmlFor={anchorId}>
          {label}
        </label>
        <input
          className="govuk-input govuk-date-input__input govuk-input--width-3"
          id={anchorId}
          data-testid={testId}
          type="number"
          step={allowFloat ? 'any' : undefined}
          value={value}
          onChange={handleChange}
          disabled={disabled ?? false}
          onKeyDown={(e) => handleKeyPress(e, { allowFloat, decimalPlaces })}
          onPaste={(e) => handlePaste(e, { allowFloat, decimalPlaces })}
          onFocus={(e) =>
            e.target.addEventListener('wheel', (e) => e.preventDefault(), { passive: false })
          }
          style={{ backgroundColor: disabled ? '#b1b4b6' : 'transparent' }}
        />
      </div>
    </div>
  );
}
